import { SelectableSite } from "../../../types/types";
const {
  Select: { default: Select },
} = window.Edocat.Components;

interface SiteSelectProps {
  onSiteSelect: Function;
  currentSite: SelectableSite;
  loadingContent: boolean;
  sites: {
    [siteName: string]: SelectableSite,
  };
}
export default class SiteSelect extends window.React.PureComponent<SiteSelectProps> {
  render() {
    const { onSiteSelect, currentSite, loadingContent, sites } = this.props;

    return (
      <div className="structure-item" style={{marginRight: '1rem', width: '300px'}}>
        <Select
          id="siteSelect"
          name="site-select"
          onChange={onSiteSelect}
          options={Object.values(sites)}
          value={currentSite.nodeRef ? currentSite : null}
          mandatory={false}
          disabled={loadingContent}
          label={window.Alfresco.messages.global['edocat.global.path-picker.select-site']}
        />
      </div>
    );
  }
}
